import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { AlertService } from '../alert/services/alert.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class BlobStorageService {

  private _blobContaniers;

  constructor(
    private alertService: AlertService,
    private _errorHandler: ErrorHandlerService,
    private _executeService: ExecuteService,
    private _http: HttpClient
  ) {
    this._blobContaniers = [];
  }


  public getContainerNames(): Observable<any> {
    const url = `${APP_SETTINGS.StorageApiUrl}/v1/blobstorage/getcontainernames`;
    return this._executeService
      .ExecuteWithToken('get', url)
      .pipe(
        catchError(this._errorHandler.handleError('blobStorageService_getContainerNames', [], true))
      );
  }

  public getContainerFolders(storageName: string, containerName: string, path: string): Observable<any> {
    const url = `${APP_SETTINGS.StorageApiUrl}/v1/blobstorage/getcontainerfolders/${storageName}/${containerName}?path=${path}`;
    return this._executeService
      .ExecuteWithToken('get', url)
      .pipe(
        catchError(this._errorHandler.handleError('blobStorageService_getContainerRoot', [], true))
      );
  }


  public handleError<T>(operation = 'operation', result?: T, ignoreNotFound: boolean = false) {
    return (error: any): Observable<T> => {
      if (error.status == undefined || error.status !== 404 || !ignoreNotFound) {
        this.alertAndLogError(operation, error);
      }
      return of(result as T);
    };
  };

  private alertAndLogError(operation: string, error: any) {
    this.alertService.add('danger', operation + ' ERROR: ' + (error.status ? error.status : error.code ? error.code : '') + ' (' + this.getErrorMessage(error) + ')');
    console.info(`${operation} failed: ${this.getErrorMessage(error)}`);
  }

  private getErrorMessage(error: any) {
    let output = "";
    if (error.error) {
      output += error.error.ExceptionMessage || error.message;
    } else {
      output += error.message ? error.message : '';
    }
    switch (error.status) {
      case 415:
        output += `. ${error.error.title}. The supported formats are the following: .jpg, .png, .webp, .tiff and .pdf`;
        break;
      default:
        output += ". Check the file size does not exceed 3 megabytes.";
        break;
    }
    return output;
  }

  public uploadFile(storageName: string, containerName: string, path: string, files: File[]) {
  const url = `${APP_SETTINGS.StorageApiUrl}/v1/blobstorage/uploadFile/${storageName}/${containerName}?path=${path}`;
  const formData: FormData = new FormData();
  files.forEach(function (file) {
    formData.append('file', file, file.name);
  });

  return this._http.post<any>(url, formData).pipe(
    catchError(this.handleError('blobStorageService_UploadFile', undefined, true))
  );
}


  public get blobContainers(): string[]
{
  return this._blobContaniers;
}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/blobStorage.service.ts